<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column">
    <mat-form-field class="spacing--margin-bottom">
      <mat-label>{{ 'crop' | translate }} </mat-label>
      <input
        type="text"
        [placeholder]="'crop' | translate"
        matInput
        formControlName="cropId"
        [matAutocomplete]="cropAutocomplete"
        data-test="edit-cropfield-crop"
      />
      <mat-autocomplete #cropAutocomplete="matAutocomplete" [displayWith]="displayCrop()">
        @for (option of filteredCrops$ | async; track option) {
          <mat-option [value]="option.id" data-test="edit-cropfield-crop-option">
            {{ option.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    <div class="flex--row flex--gutter spacing--margin-bottom">
      <mat-form-field class="flex__child--auto">
        <mat-label>{{ 'cropVariety' | translate }}</mat-label>
        <input
          type="text"
          [placeholder]="'cropVariety' | translate"
          matInput
          formControlName="cropVarietyId"
          [matAutocomplete]="cropVarietyAutocomplete"
          data-test="edit-cropfield-cropVariety"
        />
        <mat-autocomplete #cropVarietyAutocomplete="matAutocomplete" [displayWith]="displayCropVariety()">
          @for (option of filteredCropVarieties$ | async; track option) {
            <mat-option [value]="option.id" data-test="edit-cropfield-cropVariety-option">
              {{ option.name }}
            </mat-option>
          }
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <mat-form-field class="spacing--margin-bottom">
      <mat-label>{{ 'manualCrops.areaInHectares' | translate }}</mat-label>
      <input matInput agrNumber formControlName="areaInHectares" [step]="0.001" autocomplete="off" />
      @if (formGroup.get('areaInHectares')!.invalid && formGroup.get('areaInHectares')!.touched) {
        <mat-error>
          {{ 'manualCrops.areaInHectaresError' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="spacing--margin-bottom">
      <mat-label>{{ 'manualCrops.soilType' | translate }}</mat-label>
      <mat-select formControlName="soilTypeId" required>
        @for (soilType of soilTypes(); track soilType) {
          <mat-option [value]="soilType.id">{{ soilType.name }}</mat-option>
        }
      </mat-select>
      @if (formGroup.get('soilTypeId')!.invalid && formGroup.get('soilTypeId')!.touched) {
        <mat-error>
          {{ 'manualCrops.soilTypeError' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="spacing--margin-bottom">
      <mat-label>{{ 'manualCrops.name' | translate }}</mat-label>
      <input matInput formControlName="name" required />
      @if (formGroup.get('name')?.errors?.['required'] && formGroup.get('name')!.touched) {
        <mat-error>
          {{ 'manualCrops.nameError' | translate }}
        </mat-error>
      }
      @if (formGroup.get('name')?.errors?.['pattern'] && formGroup.get('name')!.touched) {
        <mat-error>
          {{ 'manualCrops.namePatternError' | translate }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field class="spacing--margin-bottom">
      <mat-label>{{ 'manualCrops.province' | translate }}</mat-label>
      <mat-select formControlName="province" required>
        @for (province of eProvince | keyvalue; track province) {
          <mat-option [value]="province.key">
            {{ province.value }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    <div class="flex--row flex--gutter">
      <div class="mat-slide-group-wrapper flex__child--auto">
        <div class="mat-slide-group mat-slide-group--match-form-field-size">
          <mat-slide-toggle
            color="primary"
            formControlName="groundwaterPreservation"
            data-test="edit-cropfield-groundwaterPreservation"
          >
            {{ 'manualCrops.groundwaterPreservation' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <div class="flex--row flex--gutter">
      <div class="mat-slide-group-wrapper flex__child--auto">
        <div class="mat-slide-group mat-slide-group--match-form-field-size">
          <mat-slide-toggle color="primary" formControlName="planetProof" data-test="edit-cropfield-planetProof">
            {{ 'manualCrops.planetProof' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>

    <div class="flex--row flex--gutter">
      <div class="mat-slide-group-wrapper flex__child--auto">
        <div class="mat-slide-group mat-slide-group--match-form-field-size">
          <mat-slide-toggle color="primary" formControlName="organic" data-test="edit-cropfield-organic">
            {{ 'manualCrops.organic' | translate }}
          </mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>
</agr-form-dialog>
